import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const AlertDialogBox = ({
  open,
  textMessage,
  handleBack,
  handleClose,
  children,
  type,
  customheight,
  customwidth
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            width: customwidth ? customwidth : "800px", 
            height: customheight ? customheight : "800px", 
            maxWidth: "90%", 
            maxHeight: "90%", 
          },
        }}
      >
         <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'grey.500',
            zIndex: 1
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {textMessage}
          </DialogContentText>
          {children}
        </DialogContent>
        {type === "cancelBooking" ? (
          <></>
        ) : (
          <DialogActions>
            <Button onClick={handleBack}>Back</Button>
            <Button onClick={handleClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default AlertDialogBox;
